import React from 'react';
import clsx from 'clsx';
import {makeStyles, useTheme, withStyles} from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import {connect} from "react-redux";
import PropertyManagerConfiguration from "./PropertyManagerConfiguration";
import PropertyManagerTowInfo from "./PropertyManagerTowInfo";
import FaxesMainPage from "./FaxesMainPage";
import EmailsMainPage from "./EmailsMainPage";
//import DispatcherInfo from "./DispatcherInfo";

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import DispatchLogInfo from "./DispatchLogInfo";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import {bindActionCreators} from "redux";
import {
  DEFAULT_VESPAAN_SERVER,
  websocket_towjob,
  websocket_towjob_delete,
  websocket_towjob_update,
  websocket_storagelot,
  websocket_storagelot_delete,
  websocket_storagelot_update,
  websocket_email,
  websocket_email_delete,
  websocket_email_update,
  websocket_fax,
  websocket_fax_delete,
  websocket_fax_update,
  websocket_message,
  websocket_message_delete,
  websocket_message_update,
  websocket_police,
  websocket_police_delete,
  websocket_police_update,
  websocket_dispatch,
  websocket_dispatch_delete,
  websocket_dispatch_update,
  websocket_privateproperty, websocket_privateproperty_delete, websocket_privateproperty_update,
  websocket_privatevehicle, websocket_privatevehicle_delete, websocket_privatevehicle_update,
  websocket_driver,
  websocket_driver_delete,
  websocket_driver_update,
  websocket_truck,
  websocket_truck_delete,
  websocket_truck_update,
  
} from "../../utils/MainConstants";
import * as MainConstants from "../../utils/MainConstants";
import {deleteAVehicle, loadVehiclesData, saveAVehicle, updateAVehicle} from "../../redux/modules/vehicle";
import {
  addPoliceToPolicesArray,
  deleteAPolice, deletePoliceFromPolicesArray,
  loadPoliceData,
  saveAPolice,
  updateAPolice, updatePoliceInPolicesArray
} from "../../redux/modules/police";

import {addMessageToMessagesArray} from "../../redux/modules/message";
import {saveATowjob} from "../../redux/modules/towjob";
import {addFaxToFaxsArray, deleteFaxFromFaxsArray, saveAFax, updateFaxInFaxsArray} from "../../redux/modules/fax";
import {loadCompanysData, selectACompany} from "../../redux/modules/company";
import {
  addCompanyPropertyToCompanyPropertysArray,
  deleteCompanyPropertyFromCompanyPropertysArray,
  loadCompanypropertysData, updateCompanyPropertyInCompanyPropertysArray
} from "../../redux/modules/companyproperty";

import {loadSingleUserData, loadUsersData, loadSingleUserAndCompanyData} from "../../redux/modules/user";
import {addTowjobToTowJobsArray, deleteTowjobFromTowJobsArray,updateTowjobInTowJobsArray} from "../../redux/modules/towjob";
import {addStoragelotToArray, deleteStoragelotFromStoragelotsArray,updateStoragelotInStoragelotsArray} from "../../redux/modules/storagelot";
//import {addEmailToEmailsArray, deleteEmailFromEmailsArray,updateEmailInEmailsArray} from "../../redux/modules/email";
import { addTruckToTrucksArray ,
  deleteTruckFromTrucksArray ,
  updateTruckInTrucksArray } from "../../redux/modules/towcompanytruck";

import { addDriverToDriversArray ,
  deleteDriverFromDriversArray ,
  updateDriverInDriversArray } from "../../redux/modules/towcompanydriver";

import {
  addPropertyVehicleToPropertyVehiclesArray,
  deletePropertyVehicleFromPropertyVehiclesArray,
  updatePropertyVehicleInPropertyVehiclesArray
} from "../../redux/modules/propertyvehicle";


import { shadows } from '@material-ui/system';
import {decodeVin} from "../../redux/modules/vin";
import {loadPdfFile} from "../../redux/modules/pdf";
import {saveAPolicenotice, updateAPolicenoticePath} from "../../redux/modules/policenotice";
import * as SockJS from "sockjs-client";
import * as Stomp from "stomp-websocket";
import {Client} from '@stomp/stompjs';
import {addEmailToEmailsArray, deleteEmailFromEmailsArray, updateEmailInEmailsArray} from "../../redux/modules/email";
import {
  addDispatchToDispatchsArray,
  deleteDispatchFromDispatchsArray,
  updateDispatchInDispatchsArray
} from "../../redux/modules/dispatchsheet";
import {now} from "moment";
//import * as MainConstants from "../../utils/MainConstants";

//import {loadCompanysData, selectACompany} from "../../redux/modules/company";


function sleep(milliseconds) {
  let timeStart = new Date().getTime();
  while (true) {
    let elapsedTime = new Date().getTime() - timeStart;
    if (elapsedTime > milliseconds) {
      break;
    }
  }
}

function sleepWithPromise(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}


const drawerWidth = 240;

const useStyles = theme => ({
  root: {
    display: 'flex',
    //marginTop:40,
    //display: 'block',
  },
  formControl: {
    //margin: theme.spacing.unit,
    minWidth: 120,
  },
  /*appBar: {
			marginTop:40,
			zIndex: theme.zIndex.drawer + 1,
			transition: theme.transitions.create(['width', 'margin'], {
					easing: theme.transitions.easing.sharp,
					duration: theme.transitions.duration.leavingScreen,
			}),
	},
	appBarShift: {
			marginTop:40,
			marginLeft: drawerWidth,
			width: `calc(100% - ${drawerWidth}px)`,
			transition: theme.transitions.create(['width', 'margin'], {
					easing: theme.transitions.easing.sharp,
					duration: theme.transitions.duration.enteringScreen,
			}),
	},*/
  /*menuButton: {
			marginRight: 36,
	},*/
  /* hide: {
			 display: 'none',
			 marginTop:40,
	 },*/
  /*drawer: {
			marginTop:40,
			width: drawerWidth,
			flexShrink: 0,
			whiteSpace: 'nowrap',
	},*/
  /*drawerOpen: {
			marginTop:40,
			width: drawerWidth,
			transition: theme.transitions.create('width', {
					easing: theme.transitions.easing.sharp,
					duration: theme.transitions.duration.enteringScreen,
			}),
	},*/
  /*drawerClose: {
			 marginTop:40,
			 transition: theme.transitions.create('width', {
					 easing: theme.transitions.easing.sharp,
					 duration: theme.transitions.duration.leavingScreen,
			 }),
			 overflowX: 'hidden',
			 width: theme.spacing.unit*7 + 1,
			 [theme.breakpoints.up('sm')]: {
					 width: theme.spacing.unit*9 + 1,
			 },
	 },*/
  /* toolbar: {
			 display: 'flex',
			 alignItems: 'center',
			 justifyContent: 'flex-end',
			 padding: theme.spacing.unit*1,
			 ...theme.mixins.toolbar,
	 },*/
  button: {
    margin: theme.spacing.unit *1 ,
    textTransform: "unset !important",
  },
  content: {
    //marginTop:40,
    flexGrow: 1,
    padding: theme.spacing.unit*0,
    textTransform: "unset !important",
  },
  dividerColorPurpole: {
    //marginTop: theme.spacing.unit * 3,
    color:"#760eb3",
    backgroundColor:"#760eb3",
  },
});

class PropertyManagerMainPage extends React.Component{
  // const classes = useStyles();
  // const theme = useTheme();
  // const [open, setOpen] = React.useState(false);
  
  state = {
    
    //selectedLocation:{},
    
    open:true,
    selectedItem:'PrivatePropertyTowing',
    anchorEl:null,
    selectedCompany:{"country":"U.S.A", "state":"Massachusetts"},
    //selectedCompany:this.props.companysArray[0],
    bgColor:'blue',
    configBgColor:'white',
    faxBgColor:'white',
    emailBgColor:'white',
    dispatchBgColor:'white',
    towBgColor:'#61b4ba',
    
    
  };
  //const [open, setOpen] = React.useState(false);
  
  constructor(props)
  {
    super(props);
    this.policeSelectList=null;
    this.stompClient = null;
    this.subscription = null;  //we use this to unsubscribe from one server events
    //this.handleDrawerOpen=this.handleDrawerOpen.bind(this);
    //this.handleDrawerClose=this.handleDrawerClose.bind(this);
    
    this.handleClick=this.handleClick.bind(this);
    this.handleClose=this.handleClose.bind(this);
    this.handleCompanyChange=this.handleCompanyChange.bind(this);
    
    
    this.connectToServerWebSocket=this.connectToServerWebSocket.bind(this);
    this.processWebSocketDataPackets=this.processWebSocketDataPackets.bind(this);
    this.subscribeToServerForWebSocketData=this.subscribeToServerForWebSocketData.bind(this);
    
    this.subscribeCallBack=this.subscribeCallBack.bind(this);
    
    //connecting to server for websocket updates
    console.log("constructor calling connectToServerWebSocket");
    this.connectToServerWebSocket();
    this.onStompConnect=this.onStompConnect.bind(this);
    this.onStompError=this.onStompError.bind(this);
    
    
    
    
    
  }
  
  async handleCompanyChange(event) {
    let { selectACompany  } = this.props;
    //event.preventDefault();
    this.setState({selectedCompany:event.target.value});
    selectACompany(event.target.value.id);
    if(this.subscription != null){
      console.log("unsubscribing");
      this.subscription.unsubscribe();
    }
    if(this.stompClient != null) {
      if(this.stompClient.status === 'CONNECTED') {
        console.log("handleCompanyChange subscribing to new company");
        this.subscription = this.stompClient.subscribe('/platewiz/company/websocketmessages/' + event.target.value.id, this.subscribeCallBack);
      }else{
        console.log("handleCompanyChange calling connectToServerWebSocket");
        await this.connectToServerWebSocket();
        console.log("handleCompanyChange stompClient is not connected");
      }
    }
    /*loadPoliceData(DEFAULT_VESPAAN_SERVER.url,event.target.value.id );
		loadStoragelotsData(DEFAULT_VESPAAN_SERVER.url, event.target.value.id);
		loadCompanypropertysData(DEFAULT_VESPAAN_SERVER.url, event.target.value.id);
		selectACompany(event.target.value.id);
		this.props.changecompany(event.target.value.id);
		updateAPolicenoticePath(DEFAULT_VESPAAN_SERVER.url,this.state.selectedCompany.id, "79926689-e452-4e60-8c51-85814058eb8e");*/
  
  }
  
  getListOfCompaniesForSelection() {
    let tempArray = this.props.companysArray;
    let returnArray=[];
    let tempReturnArray=[];
    let finalReturnArray=[];
    if (tempArray) {
      
      
      returnArray = tempArray.map((s) => {
        return(<MenuItem key={s.id} value={s}>{s.name}</MenuItem>);
        //return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
      });
      //tempArray.push(<MenuItem key="1" value ="Select A Company"> <em>Select A Company</em>  </MenuItem>);
      
      // tempReturnArray.push(<MenuItem key="1" value ="Select A Company"> <em>Select A Company</em>  </MenuItem>);
      
      // finalReturnArray = tempReturnArray.concat(returnArray);
      
      /* if(this.props.companysArray != null) {
					if (this.props.companysArray[1] != null) {
							returnArray.push( < MenuItem
							key = {this.props.companysArray[1].id}
							value = {this.props.companysArray[1].name} > < em > Select One Please < /em>  </
							MenuItem >
					)
							;
					}
			} */
      /*if(this.props.companysArray != null) {
				 if(this.props.companysArray[0] != null) {
						 this.setState({selectedCompany: this.props.companysArray[0]});
				 }
		 } */
    }
    
    
    return(returnArray);
  }
  
  
  handleClick = event => {
    //setAnchorEl(event.currentTarget);
    
    this.setState({anchorEl:event.currentTarget})
  };
  
  handleClose = (event, argItem) => {
    this.setState({anchorEl:null})
    this.setState({selectedItem:argItem});
    /*this.setState({
				towBgColor:'white', configBgColor:'white',
				faxBgColor:'white', emailBgColor:'white',
				dispathcBgColor:'white'
		})*/
    
    if(argItem == 'Configuration'){
      this.setState({
        towBgColor:'white', configBgColor:'#61b4ba',
        faxBgColor:'white', emailBgColor:'white',
        dispathBgColor:'white'
      })
    }
    
    if(argItem== 'Faxes'){
      this.setState({
        towBgColor:'white', configBgColor:'white',
        faxBgColor:'#61b4ba', emailBgColor:'white',
        dispathBgColor:'white'
      })
    }
    if(argItem == 'Emails'){
      this.setState({
        towBgColor:'white', configBgColor:'white',
        faxBgColor:'white', emailBgColor:'#61b4ba',
        dispathBgColor:'white'
      })
    }
    /*if(argItem == 'Dispatch'){
      this.setState({
        towBgColor:'white', configBgColor:'white',
        faxBgColor:'white', emailBgColor:'white',
        dispathBgColor:'#61b4ba',
      })
    }*/
    if(argItem == 'PrivatePropertyTowing'){
      this.setState({
        towBgColor:'#61b4ba', configBgColor:'white',
        faxBgColor:'white', emailBgColor:'white',
        dispathBgColor:'white'
      })
    }
  };
  
  render() {
    //const classes = useStyles();
    const {classes} = this.props;
    //const theme = useTheme;
    const theme = createMuiTheme({
      direction:'rtl'
    });
    //const [open, setOpen] = React.useState(false);
    
    this.companySelectList = this.getListOfCompaniesForSelection();
    //className={classes.button}
    return (
      
      <div style={{ marginTop:10}}>
        <Grid container>
          
          <Grid item xs={2} sm={2} style={{width:'100%'}}>
            <Button variant="outlined" color="inherit" style={{backgroundColor:this.state.configBgColor, textTransform:"none", marginLeft:4, width:'90%'}} onClick={(event) => this.handleClose(event, 'Configuration')}>
              Configuration
            </Button>
          </Grid>
          <Grid item xs={2} sm={2}>
            <Button variant="outlined"  color="inherit"  style={{backgroundColor:this.state.towBgColor,  textTransform:"none",width:'90%' }} onClick={(event) => this.handleClose(event, 'PrivatePropertyTowing')}>
              Parking Incidents
            </Button>
          </Grid>
          {/*<Grid item xs={2} sm={2}>
            <Button variant="outlined" color="inherit"  style={{backgroundColor:this.state.dispathBgColor, textTransform:"none",width:'90%'}} onClick={(event) => this.handleClose(event, 'Dispatch')}>
              Dispatch
            </Button>
          </Grid>*/}
          {/*}
          <Grid item xs={2} sm={2}>
            <Button variant="outlined" color="inherit"  boxShadow={4} style={{backgroundColor:this.state.faxBgColor, textTransform:"none",width:'90%'}} onClick={(event) => this.handleClose(event, 'Faxes')}>
              Faxes
            </Button>
          </Grid>*/}
          {/*}
          <Grid item xs={2} sm={2}>
            <Button variant="outlined" color="inherit"   style={{backgroundColor:this.state.emailBgColor, textTransform:"none", width:'90%'}} onClick={(event) => this.handleClose(event, 'Emails')}>
              Emails
            </Button>
          </Grid>*/}
          <Grid item xs={2} sm={2}>
            
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="age-helper">Property Manager</InputLabel>
              <Select
                value={this.state.selectedCompany}
                onChange={this.handleCompanyChange}
                
                useDefault={true}
                defaultValue = {this.state.selectedCompany}
              >
                
                {this.companySelectList}
              
              
              </Select>
            
            </FormControl>
          
          </Grid>
          <Grid item xs={4} sm={4}>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Divider className={classes.dividerColorPurpole}></Divider>
          
          </Grid>
        </Grid>
        
        <div className={classes.content}>
          {(this.state.selectedItem == 'Configuration') &&(<PropertyManagerConfiguration></PropertyManagerConfiguration>)}
          {(this.state.selectedItem == 'PrivatePropertyTowing') && (<PropertyManagerTowInfo selectedCompany = {this.props.selectedCompanyStore}></PropertyManagerTowInfo>)}
          {/*{(this.state.selectedItem == 'Dispatch') && (<DispatchLogInfo selectedCompany = {this.props.selectedCompanyStore} ></DispatchLogInfo>)}
          {(this.state.selectedItem == 'Faxes') && (<FaxesMainPage selectedCompany = {this.props.selectedCompanyStore} ></FaxesMainPage>)}
          {(this.state.selectedItem == 'Emails') && (<EmailsMainPage selectedCompany = {this.props.selectedCompanyStore} ></EmailsMainPage>)} */}
        </div>
      </div>
    );
  }
  
  
  
  componentDidMount(nextProps)
  {
    let { selectACompany  } = this.props;
    console.log("componentDidMount ")
    console.log(this.props.companysArray)
    //this.setState({selectedCompany: this.props.companysArray[0]});
    if((this.props.companysArray != null)  && (this.props.companysArray.length >= 1) ){
      this.setState({selectedCompany: this.props.companysArray[0]});
      selectACompany(this.props.companysArray[0].id);
      if(this.subscription != null){
        console.log("unsubscribing");
        this.subscription.unsubscribe();
      }
      
      if (this.stompClient != null) {
        if(this.stompClient.status === 'CONNECTED') {
          console.log("componentDidMount subscribing");
          this.subscription = this.stompClient.subscribe('/platewiz/company/websocketmessages/' + this.props.companysArray[0].id, this.subscribeCallBack);
        }else{
          console.log("componentDidMount calling connectToServerWebSocket");
          this.connectToServerWebSocket();
          console.log("componentDidMount stompClient is not connected");
        }
      }
    }
    
  }
  
  
  componentWillReceiveProps(nextProps)
  {
    let { selectACompany  } = this.props;
    //Farshid 7-23-2024
    //console.log("componentWillReceiveProps ")
    //console.log(nextProps.companysArray)
    
    if((this.state.selectedCompany.name == null ) &&(nextProps != null) &&(nextProps.companysArray != null)  && (nextProps.companysArray.length >= 1) ){
      this.setState({selectedCompany: nextProps.companysArray[0]});
      selectACompany(nextProps.companysArray[0].id);
      if(this.subscription != null){
        console.log("unsubscribing");
        this.subscription.unsubscribe();
      }
      
      if (this.stompClient != null) {
        if(this.stompClient.status === 'CONNECTED') {
          console.log("componentWillReceiveProps subscribing");
          this.subscription = this.stompClient.subscribe('/platewiz/company/websocketmessages/' + nextProps.companysArray[0].id, this.subscribeCallBack);
        }else{
          console.log("componentWillReceiveProps calling connectToServerWebSocket");
          this.connectToServerWebSocket();
          console.log("componentWillReceiveProps 1 stompClient is not connected");
        }
      }
    }
    
    if((this.state.selectedCompany == null )  || (this.state.selectedCompany == undefined) ){
      this.setState({selectedCompany: nextProps.companysArray[0]});
      selectACompany(nextProps.companysArray[0].id);
      if(this.subscription != null){
        console.log("componentWillReceiveProps unsubscribing");
        this.subscription.unsubscribe();
      }
      
      if (this.stompClient != null) {
        if(this.stompClient.status === 'CONNECTED') {
          console.log("componentWillReceiveProps2 subscribing");
          this.subscription = this.stompClient.subscribe('/platewiz/company/websocketmessages/' + nextProps.companysArray[0].id, this.subscribeCallBack);
        }else{
          console.log("componentWillReceiveProps calling connectToServerWebSocket");
          this.connectToServerWebSocket();
          console.log("componentWillReceiveProps 2 stompClient is not connected");
        }
      }
    }
  }
  
  componentWillMount(){
    let {loadSingleUserData, loadUsersData, loadSingleUserAndCompanyData, loadCompanysData,selectACompany  } = this.props;
    
    
    //loadUsersData(DEFAULT_VESPAAN_SERVER.url );
    //7_12_2024 loadSingleUserData(DEFAULT_VESPAAN_SERVER.url );
    //7-23-2024 loadSingleUserAndCompanyData(DEFAULT_VESPAAN_SERVER.url );
    //console.log(" I am before sleep");
    //sleep(2000) ;
    //console.log(" I am after sleep");
    //loadCompanysData(DEFAULT_VESPAAN_SERVER.url );
    //this.connectToServerWebSocket();
    /*  Commented on FARSHID JUNE_19_2025
    if((this.props.companysArray != null)  && (this.props.companysArray.length >= 1) ){
      this.setState({selectedCompany: this.props.companysArray[0]});
      selectACompany(this.props.companysArray[0].id);
      if(this.subscription != null){
        console.log("unsubscribing");
        this.subscription.unsubscribe();
      }
      if(this.stompClient != null) {
        if(this.stompClient.status === 'CONNECTED') {
          console.log("componentWillMount subscribing");
          this.subscription = this.stompClient.subscribe('/platewiz/company/websocketmessages/' + this.props.companysArray[0].id, this.subscribeCallBack);
        } else{
          console.log("componentWillMount calling connectToServerWebSocket");
          this.connectToServerWebSocket();
          console.log("componentWillMount stompClient is not connected");
        }
      }
    }*/
    
  }
  
  subscribeCallBack(messageOutput){
    let { addTowjobToTowJobsArray , addStoragelotToArray } = this.props;
    
    console.log("Farshid greating string message is " + messageOutput.body);
    var tempMessageObject = JSON.parse(messageOutput.body);
    console.log("Farshid 2 Platewiz message from  type is " + tempMessageObject.type);
    
    this.processWebSocketDataPackets(messageOutput.body);
    
    
    
    /*// let tempFucntion = addStoragelotToArray;
		//var tempMessageObject = JSON.parse(messageOutput.body);
		var webSocketMsg = JSON.parse(messageOutput.body);
		console.log(" TowCompany 2 Main Page Platewiz message from  type is " + webSocketMsg.type);
		console.log("TowCompany 2 Main Page Platewiz data from is " + webSocketMsg.data);

		console.log("TowCompany 2 Main Page Platewiz message from  from is " + webSocketMsg.data.from);
		console.log("TowCompany 2 Main Page  Platewiz message  text is " + webSocketMsg.data.text);
		if(webSocketMsg.type == websocket_towjob ){
			addTowjobToTowJobsArray(webSocketMsg.data);
		}
		*/
    
    
    //console.log("Farshid 2 Platewiz message from  from is " + tempMessageObject.data.from);
    //console.log("Farshid 2  Platewiz message  text is " + tempMessageObject.data.text);         // but might improve readability
  }
  
  
  subscribeToServerForWebSocketData(frame) {
    
    //let somepathid = "99999";
    //console.log ("The company Id is " +this.props.selectedCompany );
    console.log('subscribeToServerForWebSocketData Connected: frame is '  );
    console.log(frame);
    
    console.log ("The this.props.selectedCompanyStore Id is " +this.props.selectedCompanyStore );
    console.log('this.props.selectedCompanyStore Frame Connected: ' + frame);
    
    //if( (this.stompClient != null)  && (this.props.selectedCompany !== undefined)){
    if( (this.stompClient != null)  && (this.props.selectedCompanyStore !== undefined)){
      
      if(this.props.selectedCompanyStore != null) {
        console.log("this.props.selectedCompanyStore is ");
        console.log(this.props.selectedCompanyStore);
        console.log("subscribeToServerForWebSocketData subscribing");
        
        for(let i=0; i<1; i++) {
          
          //if (this.stompClient.status === 'CONNECTED') {
          if (this.stompClient.connected) {
            console.log("subscribeToServerForWebSocketData: I got connected- Farshid Farshid Farshid Farshid i= " + i);
            this.subscription = this.stompClient.subscribe('/platewiz/company/websocketmessages/' + this.props.selectedCompanyStore, this.subscribeCallBack);
            console.log("subscribeToServerForWebSocketData: I got connected- Farshid Farshid Farshid Farshid  breaking loop i= " + i);
            break;
          } else {
            
            console.log("The stompclient was not in connected state. State was " + this.stompClient.connected + " i= "+ i);
            console.log(this.stompClient);
          }
          //sleep(5000);
        }
      }else{
        console.log("Hey Farshid, I didn't subscribe to the websoket  the selectedCompanyStore was null");
      }
      
    } else {
      console.log("Hey Farshid Farshid Farshid , I didn't subscribe to the websoket ");
    }
    //stompClient.subscribe('/topic/greetings', function (greeting) {
    //showGreeting(JSON.parse(greeting.body).content);
    
    //console.log("Farshid greaing message is "  + JSON.parse(greeting.body).content);
    //});
    
    
  }
  
  

// ----- onConnect callback -----
  onStompConnect(frame) {
    console.log('FARSHID FARSHID ✅ STOMP connected – frame: ');
    console.log(frame);
    try {
      this.subscribeToServerForWebSocketData(frame);
    } catch(error){
      console.error("onStompConnect:I had an error "+ error.message)
    }
  }

// ----- onError / onClose callback -----
  onStompError(error) {
    console.error('FARSHID FARSHID FARSHID ❌ STOMP error:', error);
    // Implement reconnection if you want (setTimeout → connect again)
  }

// Finally, open the connection
  //stompClient.connect(connectHeaders, onConnect, onError);
  
  
  //Farshid End
  
  connectToServerWebSocket() {
    //var stompClient = null;
    //var socket = new SockJS('http://localhost:2500/app');
    //var socket = new SockJS('http://34.229.118.233:2500/app');
    var socket = new SockJS(MainConstants.DEFAULT_VESPAAN_SERVER.websocketurl);
    this.stompClient = Stomp.over(socket);
    let myAuthToken= "Bearer "+this.props.accessToken;
    let header = {
      "Authorization" : {myAuthToken}
    }
    console.log("Header is ");
    console.log(header);
    //this.stompClient.connect({}, this.subscribeToServerForWebSocketData);
    console.log("subscribing");
    console.log("We are NOT connected to WebSocket YET." + now());
    //this.stompClient.connect(header, this.subscribeToServerForWebSocketData);
    this.stompClient.connect(header, this.onStompConnect, this.onStompError);
    
  }
  /* teh new version connectToServerWebSocket() {
    //var stompClient = null;
    //var socket = new SockJS('http://localhost:2500/app');
    //var socket = new SockJS('http://34.229.118.233:2500/app');
    let myAuthToken= "Bearer "+this.props.accessToken;
    let socket = new SockJS(MainConstants.DEFAULT_VESPAAN_SERVER.websocketurl);
    this.stompClient =  new Client({
      //brokerURL:MainConstants.DEFAULT_VESPAAN_SERVER.websocketurl,
      webSocketFactory: () => socket,
      connectHeaders:{
        "Authorization" : {myAuthToken}
      },
      reconnectDelay: 5000,
      onConnect: (frame) => {
        console.log('onConnect Connected: ' + frame);
        this.stompClient.subscribe('/platewiz/company/websocketmessages/' + this.props.selectedCompanyStore, (message) => {
          console.log(" subscribe was successful");
          console.log('Received:', JSON.parse(message.body));
          this.subscribeCallBack(message);
        });
      },
      onStompError: (frame) => {
        console.error('Farshid Broker error:', frame);
      },
    });
    this.stompClient.activate();
  } */
  
  processWebSocketDataPackets(argMessageOutBody){
    
    let { addTowjobToTowJobsArray , addStoragelotToArray,deleteTowjobFromTowJobsArray, deleteStoragelotFromStoragelotsArray,
      updateStoragelotInStoragelotsArray,updateTowjobInTowJobsArray,addEmailToEmailsArray,deleteEmailFromEmailsArray, updateEmailInEmailsArray,updateFaxInFaxsArray,
      addFaxToFaxsArray, deleteFaxFromFaxsArray, addPoliceToPolicesArray,deletePoliceFromPolicesArray,updatePoliceInPolicesArray,
      addDispatchToDispatchsArray,deleteDispatchFromDispatchsArray,updateDispatchInDispatchsArray,addCompanyPropertyToCompanyPropertysArray,
      deleteCompanyPropertyFromCompanyPropertysArray,updateCompanyPropertyInCompanyPropertysArray,addPropertyVehicleToPropertyVehiclesArray,
      deletePropertyVehicleFromPropertyVehiclesArray,updatePropertyVehicleInPropertyVehiclesArray,
      addTruckToTrucksArray,
      deleteTruckFromTrucksArray,updateTruckInTrucksArray,
      addDriverToDriversArray,
      deleteDriverFromDriversArray,updateDriverInDriversArray,
      addMessageToMessagesArray,
    } = this.props;
    // let tempFucntion = addStoragelotToArray;
    //var tempMessageObject = JSON.parse(messageOutput.body);
    var webSocketMsg = JSON.parse(argMessageOutBody);
    console.log(" TowCompany 2 Main Page Platewiz message from  type is " + webSocketMsg.type);
    console.log("TowCompany 2 Main Page Platewiz data from is: "  );
    console.log( webSocketMsg.data);
    
    console.log("TowCompany 2 Main Page Platewiz message from  from is: "  );
    console.log( webSocketMsg.data.from);
    console.log("TowCompany 2 Main Page  Platewiz message  text is: " );
    console.log( webSocketMsg.data.text);
    
    if(webSocketMsg.type == websocket_towjob ){
      addTowjobToTowJobsArray( webSocketMsg.data );
    } else if(webSocketMsg.type == websocket_towjob_delete){
      deleteTowjobFromTowJobsArray( webSocketMsg.data );
    }else if(webSocketMsg.type == websocket_towjob_update){
      updateTowjobInTowJobsArray( webSocketMsg.data );
    }else if(webSocketMsg.type == websocket_storagelot ){
      addStoragelotToArray( webSocketMsg.data );
    }else if(webSocketMsg.type == websocket_storagelot_delete){
      deleteStoragelotFromStoragelotsArray( webSocketMsg.data );
    }else if(webSocketMsg.type == websocket_storagelot_update){
      updateStoragelotInStoragelotsArray( webSocketMsg.data );
    }else if(webSocketMsg.type == websocket_email ){
      addEmailToEmailsArray( webSocketMsg.data );
    }else if(webSocketMsg.type == websocket_email_delete){
      deleteEmailFromEmailsArray( webSocketMsg.data );
    }else if(webSocketMsg.type == websocket_email_update){
      updateEmailInEmailsArray( webSocketMsg.data );
    }else if(webSocketMsg.type == websocket_fax ){
      addFaxToFaxsArray( webSocketMsg.data );
    }else if(webSocketMsg.type === websocket_fax_delete){
      deleteFaxFromFaxsArray( webSocketMsg.data );
    }else if(webSocketMsg.type == websocket_fax_update){
      updateFaxInFaxsArray( webSocketMsg.data );
    }else if(webSocketMsg.type == websocket_message ){
      addMessageToMessagesArray( webSocketMsg.data );
    }/*else if(webSocketMsg.type == websocket_message_delete){
                deleteMessageFromMessagesArray( webSocketMsg.data );
              }else if(webSocketMsg.type == websocket_message_update){
                updateMessageInMessagesArray( webSocketMsg.data );
              }*/
    else if(webSocketMsg.type == websocket_police ){
      addPoliceToPolicesArray ( webSocketMsg.data );
    }else if(webSocketMsg.type == websocket_police_delete){
      deletePoliceFromPolicesArray( webSocketMsg.data );
    }else if(webSocketMsg.type == websocket_police_update){
      updatePoliceInPolicesArray( webSocketMsg.data );
    } else if(webSocketMsg.type === websocket_dispatch ){
      addDispatchToDispatchsArray ( webSocketMsg.data );
    }else if(webSocketMsg.type === websocket_dispatch_delete){
      deleteDispatchFromDispatchsArray( webSocketMsg.data );
    }else if(webSocketMsg.type === websocket_dispatch_update){
      updateDispatchInDispatchsArray( webSocketMsg.data );
    } else if(webSocketMsg.type === websocket_privateproperty ){
      console.log("Farshid I am calling  addCompanyPropertyToCompanyPropertysArray in the TowCompanyPage");
      addCompanyPropertyToCompanyPropertysArray ( webSocketMsg.data );
    }else if(webSocketMsg.type === websocket_privateproperty_delete){
      deleteCompanyPropertyFromCompanyPropertysArray( webSocketMsg.data );
    }else if(webSocketMsg.type === websocket_privateproperty_update){
      updateCompanyPropertyInCompanyPropertysArray( webSocketMsg.data );
    } else if(webSocketMsg.type === websocket_privatevehicle ){
      console.log("Farshid Adding Adding  vehicle list for property is called from web socket")
      addPropertyVehicleToPropertyVehiclesArray ( webSocketMsg.data );
    }else if(webSocketMsg.type === websocket_privatevehicle_delete){
      deletePropertyVehicleFromPropertyVehiclesArray( webSocketMsg.data );
    }else if(webSocketMsg.type === websocket_privatevehicle_update){
      console.log("Update vehicle list for property is called from web socket")
      updatePropertyVehicleInPropertyVehiclesArray( webSocketMsg.data );
    }else if(webSocketMsg.type === websocket_truck ){
      addTruckToTrucksArray ( webSocketMsg.data );
    }else if(webSocketMsg.type === websocket_truck_delete){
      deleteTruckFromTrucksArray( webSocketMsg.data );
    }else if(webSocketMsg.type === websocket_truck_update){
      updateTruckInTrucksArray( webSocketMsg.data );
    }else if(webSocketMsg.type === websocket_driver ){
      addDriverToDriversArray ( webSocketMsg.data );
    }else if(webSocketMsg.type === websocket_driver_delete){
      deleteDriverFromDriversArray( webSocketMsg.data );
    }else if(webSocketMsg.type === websocket_driver_update){
      updateDriverInDriversArray( webSocketMsg.data );
    }/*else if(webSocketMsg.type == websocket_driver ){
                addDriverToDriversArray ( webSocketMsg.data );
              }else if(webSocketMsg.type == websocket_driver_delete){
                deleteDriverFromDriversArray( webSocketMsg.data );
              }else if(webSocketMsg.type == websocket_driver_update){
                updateDriverInDriversArray( webSocketMsg.data );
              }*/
  }
  
}//End of class

const mapStateToProps = (state) => {
  return {
    companysArray: state.company.companysArray,
    towjobsArray: state.towjob.towjobsArray,
    selectedCompanyStore:state.company.selectedCompany,
    accessToken: state.login.loginData.idToken
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    addTowjobToTowJobsArray:addTowjobToTowJobsArray,
    deleteTowjobFromTowJobsArray:deleteTowjobFromTowJobsArray,
    updateTowjobInTowJobsArray:updateTowjobInTowJobsArray,
    
    addEmailToEmailsArray:addEmailToEmailsArray,
    deleteEmailFromEmailsArray:deleteEmailFromEmailsArray,
    updateEmailInEmailsArray:updateEmailInEmailsArray,
    
    //addMessageToMessagesArray:addMessageToMessagesArray,
    //deleteMessageFromMessagesArray:deleteMessageFromMessagesArray,
    //updateMessageInMessagesArray:updateMessageInMessagesArray,
    
    addFaxToFaxsArray:addFaxToFaxsArray,
    deleteFaxFromFaxsArray:deleteFaxFromFaxsArray,
    updateFaxInFaxsArray:updateFaxInFaxsArray,
    
    addPoliceToPolicesArray:addPoliceToPolicesArray,
    deletePoliceFromPolicesArray:deletePoliceFromPolicesArray,
    updatePoliceInPolicesArray:updatePoliceInPolicesArray,
    
    addDispatchToDispatchsArray:addDispatchToDispatchsArray,
    deleteDispatchFromDispatchsArray:deleteDispatchFromDispatchsArray,
    updateDispatchInDispatchsArray:updateDispatchInDispatchsArray,
    
    addCompanyPropertyToCompanyPropertysArray:addCompanyPropertyToCompanyPropertysArray,
    deleteCompanyPropertyFromCompanyPropertysArray:deleteCompanyPropertyFromCompanyPropertysArray,
    updateCompanyPropertyInCompanyPropertysArray:updateCompanyPropertyInCompanyPropertysArray,
    
    addPropertyVehicleToPropertyVehiclesArray:addPropertyVehicleToPropertyVehiclesArray,
    deletePropertyVehicleFromPropertyVehiclesArray:deletePropertyVehicleFromPropertyVehiclesArray,
    updatePropertyVehicleInPropertyVehiclesArray:updatePropertyVehicleInPropertyVehiclesArray,
    
    
    addStoragelotToArray:addStoragelotToArray,
    deleteStoragelotFromStoragelotsArray:deleteStoragelotFromStoragelotsArray,
    updateStoragelotInStoragelotsArray:updateStoragelotInStoragelotsArray,
    
    addTruckToTrucksArray:addTruckToTrucksArray,
    deleteTruckFromTrucksArray:deleteTruckFromTrucksArray,
    updateTruckInTrucksArray:updateTruckInTrucksArray,
    
    addDriverToDriversArray:addDriverToDriversArray,
    deleteDriverFromDriversArray:deleteDriverFromDriversArray,
    updateDriverInDriversArray:updateDriverInDriversArray,
    addMessageToMessagesArray:addMessageToMessagesArray,
    
    
    loadCompanysData:loadCompanysData,
    loadSingleUserData:loadSingleUserData,
    loadUsersData:loadUsersData,
    loadSingleUserAndCompanyData:loadSingleUserAndCompanyData,
    selectACompany:selectACompany,
    
  }, dispatch);
};

//export default (withStyles(useStyles)(TowCompanyMainPage));

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(PropertyManagerMainPage));
